import React from 'react';
export function Footer() {
  return <footer className="w-full bg-blush px-5 py-10" data-id="element-88" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-2xl text-center" data-id="element-89" data-mp="3gezev8fo7z39">
        <p className="font-display text-base font-semibold text-foreground" data-id="element-90" data-mp="3ggk6oqalp3xf">Aprende Coreano Fácil™</p>
        <p className="mt-2 text-xs leading-relaxed text-muted" data-id="element-91" data-mp="32pp601a99t4x">
          Método visual para aprender coreano desde cero. Descarga inmediata · Pago único · Garantía
          de 7 días.
        </p>
        <p className="mt-4 text-xs leading-relaxed text-muted" data-id="element-92" data-mp="3uftlblj5rpza">
          © {new Date().getFullYear()} Aprende Coreano Fácil. Todos los derechos reservados. ·{' '}
          <a href="#" className="underline-offset-2 transition-colors duration-150 hover:text-primary-strong hover:underline" data-id="element-93" data-mp="3ldamdcihtxib">
            Términos y condiciones
          </a>{' '}
          ·{' '}
          <a href="#" className="underline-offset-2 transition-colors duration-150 hover:text-primary-strong hover:underline" data-id="element-94" data-mp="29y5hq2ysxow2">
            Política de privacidad
          </a>
        </p>
      </div>
    </footer>;
}